import React, { Component } from 'react';
import '../CSS/newRecord.css';
import GenericNavbar from './Navbar/GenericNavbar';

import SimpleStorageContract from "../contracts/SimpleStorage.json";
import getWeb3 from "../utils/getWeb3";

class Company extends Component{
    

    constructor(props){
        super(props);
        this.state = {
            name:'',
            email:'',
            contact:'',
            amount:'',
            currency:'',
            user:'',
            created:0
        };
        this.onSubmit = this.onSubmit.bind(this);
    }
    componentDidMount = async () => {
        var user = localStorage.getItem("user");
        user = JSON.parse(user);
        if(user){
            this.setState({user:  user});
            console.log(this.state.user)
        }
    }
    onSubmit(event) {
        event.preventDefault();
        console.log(this.state);
        fetch(`http://52.60.64.107/api/orginatorx-new/create-compony.php?name=${this.state.name}
        &email=${this.state.email}&contact=${this.state.contact}&amount=${this.state.amount}&currency=${this.state.currency}`)
                    .then(response => response.json())
                    .then(data => {
                        this.setState({ name:''});
                        this.setState({ email:''});
                        this.setState({ contact:''});
                        this.setState({ amount:''});
                        this.setState({ currency:''});
                        this.setState({ created:1});
					})
    }
    render()
    {
        return(
            <div className = "">
               <nav className="nav-wrapper grey darken-4 navbar">
            <div className="container">
            <a href="/" className="brand-logo">
                        <img
                            className="header__logo"
                            src="./logo.jpg"
                            alt="logo"
                            />
                            </a>
               <ul className = "right">
                   <li active><a href = "/sender">Home</a></li>
                   {/* <li active><a href = "javascript:void(0)">Electronics record
                   <ul>
                       <li><a href = "/sender">Sender</a></li>
                       <li active><a href = "/recipient">Recipient</a></li>
                        <li><a href = "/newRecord">Request Record</a></li>
                   </ul>
                   </a>
                   </li> */}
                    {this.state.user !='' && this.state.user.user_type =='0' &&
                    <>
                   <li><a href = "/sender">Sender</a></li>
                    <li active><a href = "/recipient">Recipient</a></li>
                    <li><a href = "/newRecord">Request Record</a></li>
                   <li active><a href = "/token">Token</a></li>
                   <li active><a href = "/coin">Coin</a></li>
                   <li active><a href = "/nft">NFT</a></li>
                   </>
                    }
                    {this.state.user !='' && this.state.user.user_type =='1' &&
                    <>
                   <li><a href = "/create-company">Company master</a></li>
                    <li active><a href = "/company-list">Company list</a></li>
                   </>
                    }
                   
                   <li><a href = "/">Log out</a></li>
               </ul>
            </div>

        </nav>
                <div className="container">
                <div className="row">
                    <div className="col s8">
                        <div className="card reportCard">
                            <div className="card-title cardTitle2">
                                <h4 className = "cardTitle">Create company</h4>
                            </div>
                            <div className="card-content">
                                <form onSubmit={this.onSubmit}>
                                    <div className="input-field">
                                        <input type="text" 
                                        value={this.state.name}
                                        onChange={(evt) => { this.setState({name: evt.target.value}) }} 
                                        />
                                        <label htmlFor="email">Company name</label>
                                    </div>
                                    <div className="input-field">
                                        <input type="text"  
                                        value={this.state.email}
                                        onChange={(evt) => { this.setState({ email: evt.target.value })}} required/>
                                        <label htmlFor="email">Email</label>
                                    </div>
                                    <div className="input-field">
                                        <input type="text" 
                                        value={this.state.contact}
                                        onChange={(evt) => { this.setState({ contact : evt.target.value }) }} required/>
                                        <label htmlFor="email">Contact</label>
                                    </div>
                                    <div className="input-field">
                                        <input type="text"
                                        value={this.state.amount}
                                         onChange={(evt) => { this.setState({ amount : evt.target.value })}} required/>
                                        <label htmlFor="email">Price Per Share</label>
                                    </div>
                                    
                                    <div className="input-field">
                                        <input type="text" 
                                        value={this.state.currency}
                                        onChange={(evt) => { this.setState({ currency : evt.target.value })}} required/>
                                        <label htmlFor="offCode">Currency</label>
                                    </div>

                                    <div className="form-submit center">
                                        {this.state.created==1 &&
                                        <p>Company created successfully</p> }
                                        <button type="submit" className="dropbtn1" style={{marginTop:"10px"}}>Create</button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default Company;
